import { MouseEvent, useRef } from 'react';
import { MetamodelViewState } from './types';
import { MetamodelViewCommands } from './metamodelViewCommands';
import { createGraphInterface } from 'viewpointBuilder/components/SimpleGraph/GraphInterface';
import { SimpleGraphView } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphView';
import { SimpleGraphContainerWithGreyBackground } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphViewContainer';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { MetamodelSidePanel } from './MetamodelSidePanel';
import { WithMetamodelLoader } from '../components/WithMetamodelLoader';
import { ResizablePageBody } from '@ardoq/page-layout';
import { t, type I18nLocale } from '@ardoq/i18n';

type MetamodelViewContentProps = {
  state: MetamodelViewState;
  toggleGraphNodeSelection: (event: MouseEvent) => void;
  commands: MetamodelViewCommands;
  closeViewpointBuilder: () => void;
  i18nLocale: I18nLocale;
};
export const MetamodelViewContent = ({
  state,
  toggleGraphNodeSelection,
  commands,
  closeViewpointBuilder,
  i18nLocale,
}: MetamodelViewContentProps) => {
  const { graphNodes, graphEdges, graphGroups, shouldFitToContentOnLayout } =
    state;

  const viewModel = {
    graphNodes,
    graphEdges,
    graphGroups,
  };
  const graphInterface = useRef(createGraphInterface());

  return (
    <WithMetamodelLoader
      isMetaModelLoaded={state.isMetaModelLoaded}
      closeViewpointBuilder={closeViewpointBuilder}
      i18nLocale={i18nLocale}
    >
      <ResizablePageBody
        skipPadding
        footerContent={
          <ViewpointBuilderFooter
            closeViewpointBuilder={closeViewpointBuilder}
            i18nLocale={i18nLocale}
          />
        }
        rightContentInitialWidth={600}
        rightContent={
          <MetamodelSidePanel
            state={state}
            commands={commands}
            i18nLocale={i18nLocale}
          />
        }
      >
        <SimpleGraphContainerWithGreyBackground
          onClick={toggleGraphNodeSelection}
        >
          <SimpleGraphView
            viewModel={viewModel}
            graphInterface={graphInterface.current}
            label={t(
              i18nLocale,
              'viewpointBuilder:metaModel.viewLabel',
              'Metamodel view'
            )}
            shouldFitToContentOnLayout={shouldFitToContentOnLayout}
          />
        </SimpleGraphContainerWithGreyBackground>
      </ResizablePageBody>
    </WithMetamodelLoader>
  );
};
